import React from 'react';
import classnames from 'classnames';
import { LogoClickProperties } from '~/hooks/useLogoClickHandler';
import styles from './logo.module.scss';
import logo from './search-ready-logo.svg';

interface ILogo {
    alt: string;
    logoURL: string;
    logoClickProperties: LogoClickProperties;
}

const Logo: React.FC<ILogo> = ({ alt, logoURL, logoClickProperties: { isLogoClickable, clickLogoHandler } }) => {
    return (
        <span
            className={classnames(styles.logoWrapper, { [styles.clickable]: isLogoClickable })}
            role="link"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    clickLogoHandler();
                }
            }}
            onClick={(event) => {
                console.log('click');
                event.preventDefault();
                event.stopPropagation();

                clickLogoHandler();
            }}
            data-testid="logo"
        >
            <img
                className={styles.logoImage}
                src={logoURL}
                alt={alt}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = logo;
                }}
            />
        </span>
    );
};

export default Logo;
